import React from "react";
import { Draggable } from "@hello-pangea/dnd";
import { Icon } from "@iconify/react";
import { Avatar } from "@mui/material";
import { NavLink } from "react-router-dom";

const LeadCard = ({
  columnKey,
  task,
  index,
  onEdit,
  onDelete,
  onSkip,
  showPhoneModal,
  showWhatsAppModal,
  onReschedule
}) => {
  const { user_id = {}, complete = {}, schedule = {} } = task;

  return (
    <Draggable draggableId={task.id} index={index}>
      {(provided, snapshot) => (
        <div
          className="kanban-card bg-neutral-50 p-3 radius-8 mb-3"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            userSelect: "none",
            background: snapshot.isDragging ? "#f0f0f0" : "#ffffff",
            ...provided.draggableProps.style,
          }}
        >
          {/* Profile Picture */}
          <div className="d-flex justify-content-between align-items-center">
            <NavLink
              to={`/users-list/${user_id?._id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="radius-8 mb-2 overflow-hidden d-flex justify-content-start align-items-center gap-2 text-decoration-none"
              style={{ maxHeight: "200px" }}
            >
              <Avatar
                src={user_id?.profile_photo}
                alt="Profile"
                className=" object-fit-cover"
                sx={{ height: "50px", width: "50px" }}
              />
              <div className="d-flex flex-column justify-content-center align-items-start">
                <span className="kanban-title text-lg fw-semibold text-dark">
                  {user_id?.user_name
                    ? user_id?.user_name.charAt(0).toUpperCase() +
                    user_id?.user_name.slice(1)
                    : "NA"}
                </span>
                <span
                  className="text-md text-light"
                  style={{ marginTop: "-4px" }}
                >
                  {user_id?.phone_number}
                </span>
              </div>
            </NavLink>
            {(
              <div className="d-flex gap-2">
                <button
                  onClick={() =>
                    window.open(`/users-list/${user_id._id}`, "_blank")
                  }
                  className="bg-info-focus text-info-600 w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                >
                  <Icon icon="majesticons:eye-line" className="text-xl" />
                </button>
                <button
                  onClick={() => showWhatsAppModal()}
                  type="button"
                  className="remove-item-btn bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                >
                  <Icon icon="ic:baseline-whatsapp" />
                </button>
                <button
                  onClick={() => showPhoneModal()}
                  type="button"
                  className="remove-item-btn bg-warning-focus bg-hover-warning-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                >
                  <Icon icon="akar-icons:phone" />
                </button>
              </div>
            )}

            {/* {columnKey === "accepted" && (
              <button
                onClick={() => showPhoneModal()}
                type="button"
                className="remove-item-btn bg-warning-focus bg-hover-warning-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
              >
                <Icon icon="akar-icons:phone" />
              </button>
            )} */}
          </div>
          <label className="text-sm fw-bold text-secondary mt-3">Title</label>
          <div className="fw-medium ">{task.title}</div>

          {(columnKey === "accepted" || columnKey === "scheduled" || columnKey === "completed") && user_id?.parent_user_id?.user_name && (
            <>
              <label className="text-sm fw-bold text-secondary mt-3">Admin</label>
              <div className="fw-medium">{user_id.parent_user_id.user_name}</div>
            </>
          )}
          {columnKey === "pending" && (
            <>
              <label className="text-sm fw-bold text-secondary mt-3">Admin</label>
              <div className="fw-medium">{task?.skip?.skip_by?.user_name || '-'}</div>
            </>
          )}
          {columnKey === "completed" && (
            <>
              <label className="text-sm fw-bold text-secondary mt-3">
                Message
              </label>
              <div className="fw-medium ">{complete?.reason}</div>
            </>
          )}

          {columnKey === "scheduled" && (
            <>
              <div className="mb-3">
                <label className="text-sm fw-bold text-secondary d-block mt-3 mb-1">
                  Schedule
                </label>
                <div className="mb-1">
                  <strong>Reason:</strong> {schedule?.reason}
                </div>
                <div className="">
                  <strong>Schedule At:</strong>{" "}
                  {new Date(schedule?.schedule_date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </div>
                {/* Reschedule Button */}
                <button
                  className="btn btn-sm btn-warning mt-2"
                  onClick={() => onReschedule(task.id)}
                >
                  Reschedule
                </button>
              </div>
            </>
          )}

          <hr className="my-3" />
          <label className="text-sm fw-bold text-secondary mt-3">
            Updated At
          </label>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2 pt-2">
              <Icon icon="solar:calendar-outline" className="icon text-lg" />
              <span className="text-secondary-light">
                {new Date(task?.updatedAt).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })}
              </span>
            </div>
            {columnKey !== "completed" && (
              <div className="d-flex align-items-center justify-content-end gap-2 pt-2">
                <button
                  type="button"
                  className="btn btn-primary text-light py-1"
                  onClick={() => onSkip()}
                >
                  Skip
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default LeadCard;
